import React from 'react';
export function LogoOptions() {
  return <div className="min-h-screen bg-slate-50 py-16 px-4 sm:px-6 lg:px-8 font-sans" data-id="element-368">
      <div className="max-w-7xl mx-auto" data-id="element-369">
        <div className="text-center mb-16" data-id="element-370">
          <h1 className="text-4xl font-extrabold text-slate-900 tracking-tight mb-4" data-id="element-371">
            Logo Concepts
          </h1>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-372">
            A collection of CSS and SVG-based logo directions for Swedenmark AI.
            These can be screenshotted or used as a brief for a brand designer.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-373">
          {/* Concept 1: The Original (Gradient Square) */}
          <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-374">
            <div className="p-4 border-b border-slate-100 bg-slate-50/50" data-id="element-375">
              <h3 className="font-semibold text-slate-800" data-id="element-376">1. The Original</h3>
              <p className="text-xs text-slate-500 mt-1" data-id="element-377">
                Friendly, modern, app-like.
              </p>
            </div>
            <div className="p-12 flex-1 flex items-center justify-center bg-white" data-id="element-378">
              <div className="flex items-center gap-4" data-id="element-379">
                <div className="h-12 w-12 bg-gradient-to-br from-blue-600 to-purple-600 rounded-xl flex items-center justify-center shadow-md" data-id="element-380">
                  <span className="text-white text-xl font-bold tracking-tighter" data-id="element-381">
                    AI
                  </span>
                </div>
                <span className="text-2xl font-bold text-slate-900 tracking-tight" data-id="element-382">
                  Swedenmark AI
                </span>
              </div>
            </div>
          </div>

          {/* Concept 2: The Monogram */}
          <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-383">
            <div className="p-4 border-b border-slate-100 bg-slate-50/50" data-id="element-384">
              <h3 className="font-semibold text-slate-800" data-id="element-385">2. The Monogram</h3>
              <p className="text-xs text-slate-500 mt-1" data-id="element-386">
                Corporate, established, geometric.
              </p>
            </div>
            <div className="p-12 flex-1 flex items-center justify-center bg-white" data-id="element-387">
              <div className="flex items-center gap-4" data-id="element-388">
                <div className="relative h-12 w-12 flex items-center justify-center" data-id="element-389">
                  <svg viewBox="0 0 48 48" className="w-full h-full" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-390">
                    <path d="M24 4L4 14V34L24 44L44 34V14L24 4Z" stroke="#0f2546" strokeWidth="4" strokeLinejoin="round" data-id="element-391" />
                    <path d="M24 14L14 19V29L24 34L34 29V19L24 14Z" fill="#3b82f6" data-id="element-392" />
                  </svg>
                </div>
                <div className="flex flex-col" data-id="element-393">
                  <span className="text-xl font-black text-[#0f2546] tracking-tighter uppercase leading-none" data-id="element-394">
                    Swedenmark
                  </span>
                  <span className="text-sm font-bold text-blue-500 tracking-[0.2em] uppercase mt-1" data-id="element-395">
                    AI Systems
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Concept 3: Circuit Node */}
          <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-396">
            <div className="p-4 border-b border-slate-100 bg-slate-50/50" data-id="element-397">
              <h3 className="font-semibold text-slate-800" data-id="element-398">3. Circuit Node</h3>
              <p className="text-xs text-slate-500 mt-1" data-id="element-399">
                Technical, connected, automation-focused.
              </p>
            </div>
            <div className="p-12 flex-1 flex items-center justify-center bg-slate-900" data-id="element-400">
              <div className="flex items-center gap-4" data-id="element-401">
                <div className="h-10 w-10 relative" data-id="element-402">
                  <svg viewBox="0 0 40 40" className="w-full h-full" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-403">
                    <circle cx="20" cy="20" r="18" stroke="#3b82f6" strokeWidth="2" strokeDasharray="4 4" data-id="element-404" />
                    <circle cx="20" cy="10" r="4" fill="#60a5fa" data-id="element-405" />
                    <circle cx="11" cy="26" r="4" fill="#a78bfa" data-id="element-406" />
                    <circle cx="29" cy="26" r="4" fill="#34d399" data-id="element-407" />
                    <path d="M20 14L13 23M20 14L27 23M15 26H25" stroke="white" strokeWidth="2" strokeLinecap="round" data-id="element-408" />
                  </svg>
                </div>
                <span className="text-2xl font-medium text-white tracking-wide" data-id="element-409">
                  Swedenmark<span className="text-blue-400 font-bold" data-id="element-410">.ai</span>
                </span>
              </div>
            </div>
          </div>

          {/* Concept 4: Bold Wordmark */}
          <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-411">
            <div className="p-4 border-b border-slate-100 bg-slate-50/50" data-id="element-412">
              <h3 className="font-semibold text-slate-800" data-id="element-413">4. Bold Wordmark</h3>
              <p className="text-xs text-slate-500 mt-1" data-id="element-414">
                Editorial, confident, minimalist.
              </p>
            </div>
            <div className="p-12 flex-1 flex items-center justify-center bg-white" data-id="element-415">
              <div className="flex items-baseline" data-id="element-416">
                <span className="text-3xl font-black text-slate-900 tracking-tighter" data-id="element-417">
                  SWEDENMARK
                </span>
                <span className="text-3xl font-black text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-emerald-500 ml-1" data-id="element-418">
                  AI
                </span>
                <div className="w-2 h-2 rounded-full bg-emerald-500 ml-1 mb-1" data-id="element-419"></div>
              </div>
            </div>
          </div>

          {/* Concept 5: The Shield */}
          <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-420">
            <div className="p-4 border-b border-slate-100 bg-slate-50/50" data-id="element-421">
              <h3 className="font-semibold text-slate-800" data-id="element-422">5. The Shield</h3>
              <p className="text-xs text-slate-500 mt-1" data-id="element-423">
                Trustworthy, secure, enterprise-ready.
              </p>
            </div>
            <div className="p-12 flex-1 flex items-center justify-center bg-white" data-id="element-424">
              <div className="flex items-center gap-3" data-id="element-425">
                <div className="h-12 w-10 relative" data-id="element-426">
                  <svg viewBox="0 0 40 48" className="w-full h-full" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-427">
                    <path d="M20 2L4 8V22C4 33 11 43 20 46C29 43 36 33 36 22V8L20 2Z" fill="#0f2546" data-id="element-428" />
                    <path d="M20 12L12 26H18V36L28 22H22V12Z" fill="#3b82f6" data-id="element-429" />
                  </svg>
                </div>
                <div className="flex flex-col justify-center" data-id="element-430">
                  <span className="text-xl font-bold text-slate-800 leading-none mb-1" data-id="element-431">
                    Swedenmark
                  </span>
                  <span className="text-[10px] font-semibold text-slate-500 tracking-widest uppercase leading-none" data-id="element-432">
                    Artificial Intelligence
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Concept 6: Minimal Dot */}
          <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-433">
            <div className="p-4 border-b border-slate-100 bg-slate-50/50" data-id="element-434">
              <h3 className="font-semibold text-slate-800" data-id="element-435">6. Minimal Dot</h3>
              <p className="text-xs text-slate-500 mt-1" data-id="element-436">
                Abstract, elegant, forward-thinking.
              </p>
            </div>
            <div className="p-12 flex-1 flex items-center justify-center bg-zinc-50" data-id="element-437">
              <div className="flex items-center gap-3" data-id="element-438">
                <span className="text-2xl font-light text-zinc-800 tracking-widest lowercase" data-id="element-439">
                  swedenmark
                </span>
                <div className="flex items-center" data-id="element-440">
                  <div className="w-6 h-6 rounded-full bg-gradient-to-tr from-violet-600 to-orange-400 opacity-90 mix-blend-multiply" data-id="element-441"></div>
                  <div className="w-6 h-6 rounded-full bg-gradient-to-tr from-blue-500 to-emerald-400 opacity-90 mix-blend-multiply -ml-3" data-id="element-442"></div>
                </div>
                <span className="text-2xl font-semibold text-zinc-900 tracking-tight" data-id="element-443">
                  ai
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}